import ContentView from "Components/ContentView/ContentView";
import * as React from "react";
import styles from "./TaskTemplateBlockOverview.scss";
import TaskTemplateBlockOverviewHeader from "./TaskTemplateBlockOverviewHeader/TaskTemplateBlockOverviewHeader";
import TaskTemplateBlockView from "./TaskTemplateBlockView/TaskTemplateBlockView";
import TaskTemplateFilters from "./TaskTemplateFilters/TaskTemplateFilters";
import TaskTemplateSearch from "./TaskTemplateSearch/TaskTemplateSearch";

const TaskTemplateBlockOverview: React.FunctionComponent<{}> = () => (
    <ContentView id="cnvTaskTemplateBlockOverview">
        <TaskTemplateBlockOverviewHeader />
        <TaskTemplateSearch />
        <div className={styles.flexWrapper}>
            <TaskTemplateFilters />
            <TaskTemplateBlockView />
        </div>
    </ContentView>
);

export default TaskTemplateBlockOverview;


// WEBPACK FOOTER //
// ./src/Components/Pages/TaskTemplateBlockOverview/TaskTemplateBlockOverview.tsx